import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth-service';
import { Router } from '@angular/router';
import { ToastrService } from '../../shared/services/toastr-service';
import { catchError, throwError } from 'rxjs';

export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService)
  const router = inject(Router)
  const toastr = inject(ToastrService)

  return next(req).pipe(
    catchError((err) =>{
      console.log(err);

      if(err?.status == 401 && err?.statusText == "Unauthorized"){
        toastr.error('Action non authorisée')
        auth.removeCurrentUser()
        router.navigateByUrl('/login')
      }

      return throwError(() => err)
    })
  );

  return next(req);
};
